/* eslint-disable @typescript-eslint/no-explicit-any */
import { HTTPError, QueryClient, QueryClientConfig } from '@eigtech/ui-shared-api'
import { minutesToMilliseconds } from '@eigtech/ui-shared-dates'

export type EigQueryClientConfig = {
  onInvalidateQueries?: QueryClient['invalidateQueries']
}

export class EigQueryClient extends QueryClient {
  baseInvalidateQueries: QueryClient['invalidateQueries']
  private onInvalidateQueries: QueryClient['invalidateQueries']

  constructor(config: QueryClientConfig = {}, { onInvalidateQueries }: EigQueryClientConfig = {}) {
    super(config)

    this.onInvalidateQueries = onInvalidateQueries ? onInvalidateQueries : async () => {}
    this.baseInvalidateQueries = super.invalidateQueries

    // I feel like there was a reason I had to use `self` and the `call` method below
    // rather than using an arrow function. But I no longer remember why.
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this

    const invalidateQueries: QueryClient['invalidateQueries'] = async function (...args) {
      self.onInvalidateQueries.call(self, ...args)
      self.baseInvalidateQueries.call(self, ...args)
    }

    this.invalidateQueries = invalidateQueries
  }
}

export const defaultQueryClientConfig = (): QueryClientConfig => ({
  defaultOptions: {
    queries: {
      staleTime: minutesToMilliseconds(10),
      retry(failureCount, error: any) {
        // don't retry if error is 404 (not found)
        if (error instanceof HTTPError) {
          const responseStatus = (error as HTTPError).response.status
          if ([403, 404].includes(responseStatus)) return false
        }

        return failureCount < 3
      },
    },
  },
})
